module.exports = __webpack_public_path__ + "static/hawk-5cfbcf675a1cf501c422fdc48e1bbc0c.jpeg";